import styled from "styled-components";
import { palette } from "../styles";
import { LayoutProps } from "./layout.types";

export const StyledLayout = styled.div<LayoutProps>`
  height: ${({ pathname }) =>
    pathname?.includes("workspace") ? "calc(100vh - 57px)" : "100%"};
  min-height: 100%;
  background-color: ${palette.colors.grey_base};
  flex-grow: 1;

  & main {
    height: 100%;
    & > div {
      height: 100%;
    }
  }
`;
